// extracted by mini-css-extract-plugin
export default {"ThemeSwitcher":"ThemeSwitcher_ThemeSwitcher__gIDWi","Light":"ThemeSwitcher_Light__mGA9n"};